import {inject} from '@angular/core';
import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';

export const ServerURLInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  let isSuccess = "";
  const modifiedReq = request.clone({});
  return next(modifiedReq).pipe(
    tap({
      next: event => {
        if (event instanceof HttpResponse) {
          isSuccess = "success";
        }
      },
      error: error => {
        console.error("Request ", error);
        if(router.url.startsWith("/login")){
          return;
        }
        switch (error.status) {
          case 400:
            break;
          case 401:
            // 带上当前地址，登录成功后可跳回原页面（登录页读取 queryParams["redirect"]）
            window.location.href='/login?redirect='.concat(encodeURIComponent(router.url));
            break;
          case 402:
          case 403:
          case 404:
          case 500:
            break;
          default:
        }
      },
      finalize: () => console.log("Request ", isSuccess)
    })
  );
}
